import { createContext } from 'react';

/**
 * The body's inset. Both shells drop their own horizontal padding so the body can take it on the
 * inside: focus rings are drawn outside a control's border box, and the body is often the element
 * that scrolls and so clips them. It sits on the body itself, merged under the caller's classes,
 * so a caller can still replace it. `2xs` clears the widest ring (Button's, with its offset).
 */
export const FORM_SHELL_BODY_INSET = 'px-xl py-2xs';

/** Set by the shell holding the body; absent where the shell already pads the body's slot. */
export const FormShellBodyInsetContext = createContext<string | undefined>(undefined);
